/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.hero-banner__jump-link' ).on( 'click', function( e ) {
        const link = $( this ).attr( 'href' );

        const target = document.querySelector( link );
        if ( !target ) return;

        target.focus( {preventScroll: true} );
      } );

      $( '.hero-banner__jump-links-wrapper' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--hero-banner' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          centerMode: true,
          gap: '20px',
          autoWidth: true,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
